// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__mS_Lu","label":"Labeled_label__28a3W","divider":"Labeled_divider__W4VWF"};